export const IMAGES = {
  hero: "/hero.jpg",
  alma: "/brand-alma.png",
  aerodeals: "/brand-aerodeals.png",
  lifestyle: "/brand-pilotcouture.png",
  digital: "/brand-mm.jpg",
  founder: "/founder.png",
  cta: "/cta.jpg",
};

export const NAV_LINKS = [
  { label: "Brands", target: "ecosystem" },
  { label: "Visione", target: "philosophy" },
  { label: "Founder", target: "founder" },
];

export const ECOSYSTEM = [
  {
    index: "01",
    slug: "alma",
    name: "ALMA Aviation Studio",
    tag: "Aviation",
    image: IMAGES.alma,
    url: "https://almaaviationstudio.it",
    desc: "Esperienze esclusive, eventi e produzioni dedicate al mondo dell'aviazione.",
    cta: "Scopri ALMA",
  },
  {
    index: "02",
    slug: "aerodeals",
    name: "AeroDeals",
    tag: "Marketplace",
    image: IMAGES.aerodeals,
    url: "https://aerodeals.it",
    desc: "Il marketplace dedicato alla compravendita di velivoli in Italia ed Europa.",
    cta: "Visita AeroDeals",
  },
  {
    index: "03",
    slug: "pilot-couture",
    name: "Pilot Couture",
    tag: "Lifestyle",
    image: IMAGES.lifestyle,
    url: "https://pilotcouture.it",
    desc: "Un brand lifestyle che interpreta la cultura del volo attraverso un'estetica essenziale e contemporanea.",
    cta: "Scopri Pilot Couture",
  },
  {
    index: "04",
    slug: "mm-web-designers",
    name: "M&M Web Designers",
    tag: "Digital",
    image: IMAGES.digital,
    url: "https://mm-webdesigners.it",
    desc: "Progettiamo siti web, identità digitali e strumenti pensati per aiutare aziende e professionisti a crescere online.",
    cta: "Visita M&M",
  },
];

export const VALUES = [
  { key: "PRECISION", desc: "La precisione del cockpit applicata a ogni progetto." },
  { key: "VISION", desc: "Guardare oltre il presente e costruire il futuro." },
  { key: "EXCELLENCE", desc: "Ogni dettaglio conta." },
  { key: "MOTION", desc: "Un approccio dinamico, sempre orientato alla crescita." },
];

export const FOOTER_LINKS = [
  { label: "ALMA Aviation Studio", url: "https://almaaviationstudio.it" },
  { label: "AeroDeals", url: "https://aerodeals.it" },
  { label: "Pilot Couture", url: "https://pilotcouture.it" },
  { label: "M&M Web Designers", url: "https://mm-webdesigners.it" },
];
